import { createFileRoute, SearchSchemaInput } from "@tanstack/react-router";

import ChallengeOverview from "@/components/ChallengeOverview/ChallengeOverview";
import ChallengeTypeSelector from "@/components/ChallengeOverview/ChallengeTypeSelector";
import ChallengeDetailsForm from "@/components/ChallengeProfile/ChallengeDetailsForm";
import ChallengeProfile from "@/components/ChallengeProfile/ChallengeProfile";

const Component = () => {
  const search = Route.useSearch();
  return (
    <ChallengeOverview initialTab="profile">
      {!search.type ? (
        <ChallengeTypeSelector />
      ) : (
        <ChallengeProfile isCreating>
          <ChallengeDetailsForm challengeType={search.type} />
        </ChallengeProfile>
      )}
    </ChallengeOverview>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/create")({
  component: Component,
  validateSearch: ({
    type,
  }: { type?: string } & SearchSchemaInput): {
    type: "CHECKIN" | undefined;
  } => {
    if (type === "CHECKIN") {
      return { type };
    }
    return { type: undefined };
  },
});
